import { Button } from "@/components/ui/button";
import { Play } from "lucide-react";
import { useTranslation } from "react-i18next";

interface InitializeVisitButtonProps {
  onClick: () => void;
  children?: React.ReactNode;
  disabled?: boolean;
}

export const InitializeVisitButton = ({
  onClick,
  children,
  disabled = false,
}: InitializeVisitButtonProps) => {
  const { t } = useTranslation();
  const buttonText = children || t("contractorVisits.initializeVisit.button");

  return (
    <Button
      onClick={onClick}
      className="w-full h-12 text-base font-medium"
      size="lg"
      disabled={disabled}
    >
      <Play className="w-5 h-5 mr-2" />
      {buttonText}
    </Button>
  );
};
